import z from 'zod';
import { CONFIG_KEYS } from '../../constants/config.constants';

export const configSchemaRef = 'config';

export const configSchema = z
	.object({
		[CONFIG_KEYS.ANALYTICS_ENABLED]: z.boolean().default(false),
		[CONFIG_KEYS.CUSTOM_PAGES_ENABLED]: z.boolean().default(false),
		[CONFIG_KEYS.MAX_CUSTOM_PAGES]: z.number().int().min(0).default(0),
		[CONFIG_KEYS.MULTI_CURRENCY_ENABLED]: z.boolean().default(false),
		[CONFIG_KEYS.NEWS_LETTER_SUBSCRIPTION_ENABLED]: z
			.boolean()
			.default(false),
		[CONFIG_KEYS.POSTERS_ENABLED]: z.boolean().default(false),
		[CONFIG_KEYS.SUPPORTED_CURRENCIES]: z
			.array(z.string())
			.default(['ILS']),
		[CONFIG_KEYS.TELEGRAM_BOT_ENABLED]: z.boolean().default(false),
		[CONFIG_KEYS.TRACK_ORDER_ENABLED]: z.boolean().default(false),
	})
	.meta({
		description: 'Schema for the config entity.',
		ref: configSchemaRef,
		example: {
			analyticsEnabled: true,
			customPagesEnabled: true,
			maxCustomPages: 5,
			multiCurrencyEnabled: true,
			newsletterSubscriptionEnabled: false,
			postersEnabled: true,
			supportedCurrencies: ['USD', 'EUR', 'ILS'],
			telegramBotEnabled: false,
			trackOrderEnabled: true,
		},
	})
	.strict();

export type ConfigSchemaType = z.infer<typeof configSchema>;
